export abstract class ICopyable<T> {
  abstract copy_from(source: T): void;
}
